<template>
  <li class="app-articles-item">
    <h4 class="app-articles-item__title">
      <a :href="href" target="_blank">{{ article.title }}</a>
      <span v-if="!simple">
        <span class="app-articles-item__icon" @click="handleEdit">
          <el-tooltip effect="dark" content="编辑" placement="top">
            <app-svg-icon icon-class="edit"></app-svg-icon>
          </el-tooltip>
        </span>
        <span class="app-articles-item__icon" @click="handleDelete">
          <el-tooltip effect="dark" content="删除" placement="top">
            <app-svg-icon icon-class="delete"></app-svg-icon>
          </el-tooltip>
        </span>
      </span>
    </h4>
    <div class="app-articles-item__tip" v-if="article.isAuditReject">
      <span class="app-articles-item__tip__label">[审核未通过原因]</span>
      <span class="app-articles-item__tip__value">{{ article.auditMessage }}</span>
    </div>
    <div class="app-articles-item__meta">
      <span class="app-articles-item__mete__item">{{ article.time | formatDate(format) }}</span>
    </div>
  </li>
</template>

<script>
const { VUE_APP_CLOUD_SITE_SERVER } = process.env

export default {
  name: 'AppArticlesItem',
  props: {
    simple: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss'
    },
    article: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },

    href () {
      return `${VUE_APP_CLOUD_SITE_SERVER}/a${this.article.id}`
    }
  },

  methods: {
    handleEdit () {
      this.$emit('edit', this.article.id)
    },

    handleDelete () {
      this.$emit('delete', this.article.id)
    }
  }
}
</script>

<style lang="scss">
.app-articles-item {
  padding: 10px 0;
  border-bottom: 1px solid #eee;

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0;
    margin-bottom: 10px;
    font-weight: 400;

    > a:hover {
      color: $primary-color;
    }
  }

  &__icon {
    display: inline-block;
    margin-left: 15px;
    color: #ccc;
    cursor: pointer;

    &:hover {
      color: $primary-color;
    }
  }

  &__tip {
    margin-bottom: 5px;
    font-size: 12px;

    &__label {
      color: #f30;
    }

    &__value {
      color: #666;
    }
  }

  &__meta {
    color: #999;
  }
}
</style>
